module.exports = __webpack_public_path__ + "static/media/farnum.0224ff83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/farnum.jpg
// module id = 202
// module chunks = 0